"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createDOMCanvas = void 0;
/**
 * Can be passed to {@link Device.constructor} in browser-based applications.
 */
function createDOMCanvas() {
    return document.createElement("canvas");
}
exports.createDOMCanvas = createDOMCanvas;
//# sourceMappingURL=createDOMCanvas.js.map